import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper } from "../../Styles/PageStyles";
import Images from "../../../Images";
import tw from "tailwind-styled-components";
import Config, { PaginationLimit } from "../../../Config";
import { IoCopySharp, IoEye } from "react-icons/io5";
import moment from "moment";
import { capitalizeFirstLetter, handleCopy, truncateText } from "../../../helpers";
import { useNavigate } from "react-router-dom";
import { MdOutlineChevronRight } from "react-icons/md";
import Tooltip from "../../Tooltip";

const Table = ({
    apiData,
    setSelectedData,
    handleFetch,
    payLandlordRentLoading,
}) => {
    const storageKey = `landlords_lease_page`;
    const navigate = useNavigate();
    const [data, setData] = useState([
        {
            deviceName: "",
            extractionTime: "",
            processingTime: "",
            drops: "",
            action: "",
        },
    ]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
    const [previousId, setPreviousId] = useState(null);
    //const [currentPage, setCurrentPage] = useState(0);
    const [openActionMenu, setOpenActionMenu] = useState(null);
    const [processingRentPayment, setProcessingRentPayment] = useState(null); // Track which row is processing payment

    // Load saved page index
    const storageValue = sessionStorage.getItem(storageKey);
    const savedPage = storageValue !== null ? Number(storageValue) : 0;
    const [currentPage, setCurrentPage] = useState(savedPage);
    useEffect(() => {
        setCurrentPage(savedPage);
    }, [savedPage]);

    const toggleRow = (index) => {
        setSelectedRow(selectedRow === index ? null : index);
    };

    const ActionBtns = (item) => {
        return (
            <Tooltip label="View details">
                <button
                    onClick={() => leaseProperty(item)}
                    className="px-2 ml-auto text-gray-400 hover:text-gray-700 transition"
                >
                    <MdOutlineChevronRight size={22} />
                </button>
            </Tooltip>
        );
    };


    const leaseProperty = (item) => {
        setSelectedData(item);
        if (item.type === Config.PROPERTY_TYPE.PG) {
            handleFetch({ propId: item.propId });
        } else {
            handleFetch({ propId: item.propId, flatId: item.flatId });
        }
    };

    useEffect(() => {
        if (apiData) {
            const tempData = apiData.map((item) => ({
                name: getName(item),
                agreementDuration: agreementDuration(item),
                rent: (
                    <span className="text-sm font-semibold text-gray-900">
                        ₹{item.rent}
                    </span>
                ),
                rentDate: getRent(item),
                property: getProperty(item),
                security: '₹' + item.security,
                action: ActionBtns(item),
            }));
            setData(tempData);
        }
    }, [apiData, openActionMenu, payLandlordRentLoading, processingRentPayment]);


    const getProperty = (item) => {
        const propertyName = capitalizeFirstLetter(item?.propertyName || 'N/A');
        const flatName = item?.flatName
            ? `Flat ${item.flatName}`
            : null;

        return (
            <div className="flex flex-col max-w-[220px]">
                <span className="text-sm text-gray-900 truncate">
                    {propertyName}
                </span>

                {flatName ? (
                    <div className="mt-1">
                        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs  bg-gray-100 text-gray-600 border border-gray-200">
                            {flatName}
                        </span>
                    </div>
                ) : (
                    null
                )}
            </div>
        );
    };

    const getRent = (item) => {
        const day = item.rentDate
            ? moment(item.rentDate).format("Do")
            : moment(item.startDate).format("Do");

        return (
            <span className="text-xs font-medium text-gray-600 bg-gray-100 px-3 py-1 rounded-full inline-flex">
                Every {day}
            </span>
        );
    };


    // const getRent = (item) => {
    //     return <span className="text-gray-700 text-sm flex bg-neutral-100 px-3 py-1 rounded-md inline-flex">{item.rentDate ? `Every ${moment(item.rentDate).format("Do")}` : `Every ${moment(item.startDate).format("Do")}`}</span>
    // };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                !event.target.closest("#menuOptions") &&
                !event.target.closest(".action-btn")
            ) {
                setOpenActionMenu(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const agreementDuration = (item) => {
        return (
            <div className="flex flex-col text-xs text-gray-500">
                <span>
                    {item.startDate
                        ? moment(item.startDate).format("DD MMM YY")
                        : "-"}
                </span>
                <span>
                    {item.endDate
                        ? moment(item.endDate).format("DD MMM YY")
                        : "-"}
                </span>
            </div>
        );
    };


    const getName = (item) => {
        const name = capitalizeFirstLetter(item?.landlordName || "N/A");
        return (
            <UserImageWrapper>
                <UserImage
                    src={item.profilePicture || Images.Avatar}
                    alt={name}
                />

                <div className="flex flex-col min-w-0">
                    <span className="text-sm font-medium text-gray-900 truncate max-w-[180px]">
                        {name}
                    </span>

                    <div className="flex items-center gap-1 text-xs text-gray-500">
                        <span>#{item.landlordMobile}</span>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleCopy(item.landlordMobile);
                            }}
                            className="hover:text-gray-600 transition"
                            title="Copy number"
                        >
                            <IoCopySharp size={12} />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };


    const getNameOld = (item) => {
        const name = capitalizeFirstLetter(item?.landlordName || 'N/A');
        return (
            <UserImageWrapper>
                <div className="flex-row flex">
                    <UserImage src={item.profilePicture ? item.profilePicture : Images.Avatar} alt={`Avatar for ${item.landlordName}`} />
                </div>
                <div className="flex flex-col gap-1">
                    <span className="text-gray-600 text-sm font-medium block max-w-[160px] break-words line-clamp-2">
                        {truncateText(name, 35)}{" "}
                    </span>
                    <div className="flex gap-1">
                        <span className="text-gray-400 text-xs">#{item.landlordMobile}</span>
                        <button onClick={(e) => {
                            e.stopPropagation();
                            handleCopy(item.landlordMobile);
                        }}>
                            <IoCopySharp size={10} className="text-gray-400" />
                        </button>
                    </div>
                </div>
            </UserImageWrapper>
        );
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const columns = React.useMemo(() => {
        if (isMobileView) {
            return [
                {
                    Header: "Name",
                    accessor: "name",
                },
                {
                    Header: "Property",
                    accessor: "property",
                },
            ];
        }
        return [
            {
                Header: "Landlord",
                accessor: "name",
            },
            {
                Header: "Property",
                accessor: "property",
            },
            {
                Header: "Rent",
                accessor: "rent",
            },
            {
                Header: "Rent Date",
                accessor: "rentDate",
            },
            {
                Header: "Agmt Duration",
                accessor: "agreementDuration",
            },
            {
                Header: "",
                accessor: "action",
            },
        ];
    }, [isMobileView]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        pageOptions,
        page,
        state: { pageIndex },
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
    } = useTable(
        {
            data,
            columns,
            initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
        },
        useSortBy,
        usePagination
    );

    useEffect(() => {
        //setCurrentPage(pageIndex);
        sessionStorage.setItem(storageKey, pageIndex);
    }, [pageIndex, storageKey]);

    return (
        <>
            <CustomTable {...getTableProps()}>
                <Thead>
                    {headerGroups.map((headerGroup) => (
                        <Tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column) => (
                                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                    {column.render("Header")}
                                    <span>
                                        {column.isSorted ? (
                                            <img
                                                src={Images.Arrow}
                                                alt="down arrow"
                                                className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                                                    } w-1.5 inline-block ml-1.5`}
                                            />
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                </Th>
                            ))}
                        </Tr>
                    ))}
                </Thead>
                <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
                    {page.map((row, rowIndex) => {
                        prepareRow(row);
                        const rowData = apiData[rowIndex];
                        return (
                            <React.Fragment key={rowIndex}>
                                <Tr
                                    {...row.getRowProps({ style: { height: "80px" } })}
                                    hasdata={(apiData?.length > 0).toString()}
                                >
                                    {row.cells.map((cell, cellIndex) => {
                                        return (
                                            <Td
                                                {...cell.getCellProps()}
                                                onClick={() => {
                                                    if (
                                                        cellIndex === 0 ||
                                                        (cellIndex === 1 && window.innerWidth < 768)
                                                    ) {
                                                        toggleRow(rowIndex);
                                                    }
                                                }}
                                            >
                                                {cell.render("Cell")}
                                            </Td>
                                        );
                                    })}
                                </Tr>
                                {selectedRow === rowIndex && window.innerWidth < 768 && (
                                    <Tr>
                                        <Td colSpan={columns.length}>
                                            <ul className="flex flex-col gap-2">
                                                <li>
                                                    <strong>Rent</strong>{" "}
                                                    {data[rowIndex].rent}
                                                </li>
                                                <li>
                                                    <strong>Rent Date</strong>{" "}
                                                    {data[rowIndex].rentDate}
                                                </li>
                                                <li>
                                                    <strong>Agreement Duration</strong>{" "}
                                                    {data[rowIndex].agreementDuration}
                                                </li>
                                                <li>
                                                    <strong>Action</strong>{" "}
                                                    {data[rowIndex].action}
                                                </li>
                                            </ul>
                                        </Td>
                                    </Tr>
                                )}
                            </React.Fragment>
                        );
                    })}
                </Tbody>
            </CustomTable>
            {apiData?.length > 0 && (
                <PaginationWrapper>
                    <div className="px-2">
                        Page{" "}
                        <em>
                            {pageIndex + 1} of {pageOptions.length}
                        </em>
                    </div>

                    <div className="flex gap-1">
                        <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
                            <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
                        </PrevBtn>
                        <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
                            <img
                                src={Images.Arrow}
                                alt="arrow"
                                className="w-2 rotate-180 opacity-75"
                            />
                        </NextBtn>
                    </div>
                </PaginationWrapper>
            )}
        </>
    );
};

const CustomTable = tw.table` w-full text-gray-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
const Tr = tw.tr`${(props) =>
    props.hasdata === "true"
        ? "border-b"
        : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const UserImageWrapper = tw.div` flex items-center gap-2`;
const UserImage = tw.img`w-10 h-10 rounded-full `;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-10 rounded-lg shadow-lg border border-gray-200 flex flex-col`;

export default Table;